import React, { FC } from "react";
import NavigationItem from "./NavigationItem";
import { NAVIGATION_AUTH } from "data/navigationRadar";

interface Props {
  className?: string;
}

const NavigationAuth: FC<Props> = ({ className = "flex" }) => {
  return (
    <ul className={`nc-Navigation items-center ${className}`}>
      {NAVIGATION_AUTH.map((item) => (
        <NavigationItem key={item.id} menuItem={item} />
      ))}
    </ul>
  );
};

export default NavigationAuth;
